import React, { ReactNode } from "react";
import styled from "styled-components";

import { useModal } from "@examspark/common-app";
import {
  Button,
  Modal as BaseModal,
  Label,
  CheckboxInput,
  VSpace,
  Toolbar,
} from "@examspark/common-ui";
import { IconNotepadLine } from "@examspark/common-ui/dist/components/icons";

import Modal from "../common/Modal";

type Props = {
  columnOptions?: Array<{ value: string; label: string }>;
  columnValue?: string[];
  onColumnChange?: (value: string[]) => void;

  showAllNotes: boolean;
  setShowAllNotes: (value: boolean) => void;

  showAnnotationCcrs: boolean;
  onShowAnnotationCcrsChange: (value: boolean) => void;
  showAnnotationRcfp: boolean;
  onShowAnnotationRcfpChange: (value: boolean) => void;

  children?: ReactNode;
  disabled?: boolean;
};

const CheckboxLabel = styled(Label)`
  & > input[type="checkbox"] {
    order: -1;
  }
`;

export const VerticalAlignmentSettings = ({
  showAllNotes,
  setShowAllNotes,

  showAnnotationCcrs,
  onShowAnnotationCcrsChange,
  showAnnotationRcfp,
  onShowAnnotationRcfpChange,

  children,
  disabled,
}: Props) => {
  const modal = useModal();

  return (
    <>
      <Modal size="medium" title="View Settings" {...modal.modalProps}>
        <BaseModal.PaddedBody>
          <VSpace>
            <Toolbar>
              <Button
                onClick={() => setShowAllNotes(!showAllNotes)}
                title={"Toggle Specificity"}
              >
                {showAllNotes ? "Hide All Specificity" : "Show All Specificity"}
              </Button>
            </Toolbar>
            <CheckboxLabel label="Show TxRCFP" layout="row">
              <CheckboxInput
                checked={showAnnotationRcfp}
                onChange={() => onShowAnnotationRcfpChange(!showAnnotationRcfp)}
                title={"Show TxRCFP"}
              />
            </CheckboxLabel>
            <CheckboxLabel label="Show CCRS" layout="row">
              <CheckboxInput
                checked={showAnnotationCcrs}
                onChange={() => onShowAnnotationCcrsChange(!showAnnotationCcrs)}
                title={"Show CCRS"}
              />
            </CheckboxLabel>
          </VSpace>
        </BaseModal.PaddedBody>
      </Modal>
      <Button
        title="View Settings"
        onClick={modal.open}
        variant="plain"
        disabled={disabled}
      >
        {children ?? <IconNotepadLine width="16" />}
      </Button>
    </>
  );
};
